var map = {
	"./cms.svg": "fHET",
	"./cums.svg": "bMu0",
	"./custmanager.svg": "j4Qv",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./group.svg": "hjGX",
	"./home.svg": "U9Ws",
	"./integralMall.svg": "Vswo",
	"./invitation.svg": "W6jK",
	"./live.svg": "ZkmS",
	"./liveproduct.svg": "zOj1",
	"./liveroom.svg": "EoEr",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./notice.svg": "MqGM",
	"./optionSetting.svg": "1Xoc",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./photos.svg": "exhX",
	"./picture.svg": "3n9f",
	"./popular.svg": "mh1x",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./productSetting.svg": "8c5Q",
	"./recommend.svg": "rtce",
	"./return-addr.svg": "xmpI",
	"./sale.svg": "LguS",
	"./settlement.svg": "bYnt",
	"./shop-manager.svg": "mvUF",
	"./shop.svg": "hert",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./stored.svg": "ne3A",
	"./subject.svg": "00H7",
	"./switch.svg": "qyXC",
	"./table.svg": "oSYw",
	"./tenant.svg": "GNcA",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3",
	"./vip.svg": "WRQj",
	"./viplevel.svg": "N0Rt",
	"./withdrawal.svg": "+4WA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 4